import { render, staticRenderFns } from "./pdaPermission.vue?vue&type=template&id=f4b94a9a&scoped=true"
import script from "./pdaPermission.vue?vue&type=script&lang=js"
export * from "./pdaPermission.vue?vue&type=script&lang=js"
import style0 from "./pdaPermission.vue?vue&type=style&index=0&id=f4b94a9a&lang=scss&scoped=true"
import style1 from "./pdaPermission.vue?vue&type=style&index=1&id=f4b94a9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b94a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4b94a9a')) {
      api.createRecord('f4b94a9a', component.options)
    } else {
      api.reload('f4b94a9a', component.options)
    }
    module.hot.accept("./pdaPermission.vue?vue&type=template&id=f4b94a9a&scoped=true", function () {
      api.rerender('f4b94a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/positionManage/pda/pdaPermission.vue"
export default component.exports